import CAProvinces from 'provinces-ca';
import { UsaStates } from 'usa-states';
export const US_STATES = new UsaStates({
    includeTerritories: true,
    exclude: ['PW', 'MH', 'FM'],
    ignoreCharacter: '$',
    contiguousOnly: false,
}).states.map(({ name, abbreviation }) => ({
    name,
    abbreviation,
}));
export const MILITARY_US_STATES = [
    { name: 'Armed Forces America', abbreviation: 'AA' },
    { name: 'Armed Forces Europe', abbreviation: 'AE' },
    { name: 'Armed Forces Pacific', abbreviation: 'AP' },
];
export const CA_STATES = CAProvinces.map(({ name, abbreviation }) => ({
    name,
    abbreviation,
}));
export const JP_STATES = [
    { name: 'Aichi', abbreviation: 'Aichi' },
    { name: 'Akita', abbreviation: 'Akita' },
    { name: 'Aomori', abbreviation: 'Aomori' },
    { name: 'Chiba', abbreviation: 'Chiba' },
    { name: 'Ehime', abbreviation: 'Ehime' },
    { name: 'Fukui', abbreviation: 'Fukui' },
    { name: 'Fukuoka', abbreviation: 'Fukuoka' },
    { name: 'Fukushima', abbreviation: 'Fukushima' },
    { name: 'Gifu', abbreviation: 'Gifu' },
    { name: 'Gunma', abbreviation: 'Gunma' },
    { name: 'Hiroshima', abbreviation: 'Hiroshima' },
    { name: 'Hokkaido', abbreviation: 'Hokkaido' },
    { name: 'Hyogo', abbreviation: 'Hyogo' },
    { name: 'Ibaraki', abbreviation: 'Ibaraki' },
    { name: 'Ishikawa', abbreviation: 'Ishikawa' },
    { name: 'Iwate', abbreviation: 'Iwate' },
    { name: 'Kagawa', abbreviation: 'Kagawa' },
    { name: 'Kagoshima', abbreviation: 'Kagoshima' },
    { name: 'Kanagawa', abbreviation: 'Kanagawa' },
    { name: 'Kochi', abbreviation: 'Kochi' },
    { name: 'Kumamoto', abbreviation: 'Kumamoto' },
    { name: 'Kyoto', abbreviation: 'Kyoto' },
    { name: 'Mie', abbreviation: 'Mie' },
    { name: 'Miyagi', abbreviation: 'Miyagi' },
    { name: 'Miyazaki', abbreviation: 'Miyazaki' },
    { name: 'Nagano', abbreviation: 'Nagano' },
    { name: 'Nagasaki', abbreviation: 'Nagasaki' },
    { name: 'Nara', abbreviation: 'Nara' },
    { name: 'Niigata', abbreviation: 'Niigata' },
    { name: 'Oita', abbreviation: 'Oita' },
    { name: 'Okayama', abbreviation: 'Okayama' },
    { name: 'Okinawa', abbreviation: 'Okinawa' },
    { name: 'Osaka', abbreviation: 'Osaka' },
    { name: 'Saga', abbreviation: 'Saga' },
    { name: 'Saitama', abbreviation: 'Saitama' },
    { name: 'Shiga', abbreviation: 'Shiga' },
    { name: 'Shimane', abbreviation: 'Shimane' },
    { name: 'Shizuoka', abbreviation: 'Shizuoka' },
    { name: 'Tochigi', abbreviation: 'Tochigi' },
    { name: 'Tokushima', abbreviation: 'Tokushima' },
    { name: 'Tokyo', abbreviation: 'Tokyo' },
    { name: 'Tottori', abbreviation: 'Tottori' },
    { name: 'Toyama', abbreviation: 'Toyama' },
    { name: 'Wakayama', abbreviation: 'Wakayama' },
    { name: 'Yamagata', abbreviation: 'Yamagata' },
    { name: 'Yamaguchi', abbreviation: 'Yamaguchi' },
    { name: 'Yamanashi', abbreviation: 'Yamanashi' },
];
export const AU_STATES = [
    { name: 'Australian Capital Territory', abbreviation: 'ACT' },
    { name: 'New South Wales', abbreviation: 'NSW' },
    { name: 'Northern Territory', abbreviation: 'NT' },
    { name: 'Queensland', abbreviation: 'QLD' },
    { name: 'South Australia', abbreviation: 'SA' },
    { name: 'Tasmania', abbreviation: 'TAS' },
    { name: 'Victoria', abbreviation: 'VIC' },
    { name: 'Western Australia', abbreviation: 'WA' },
];
export const BR_STATES = [
    { name: 'Acre', abbreviation: 'AC' },
    { name: 'Alagoas', abbreviation: 'AL' },
    { name: 'Amazonas', abbreviation: 'AM' },
    { name: 'Amapá', abbreviation: 'AP' },
    { name: 'Bahia', abbreviation: 'BA' },
    { name: 'Ceará', abbreviation: 'CE' },
    { name: 'Distrito Federal', abbreviation: 'DF' },
    { name: 'Espírito Santo', abbreviation: 'ES' },
    { name: 'Goiás', abbreviation: 'GO' },
    { name: 'Maranhão', abbreviation: 'MA' },
    { name: 'Minas Gerais', abbreviation: 'MG' },
    { name: 'Mato Grosso do Sul', abbreviation: 'MS' },
    { name: 'Mato Grosso', abbreviation: 'MT' },
    { name: 'Pará', abbreviation: 'PA' },
    { name: 'Paraíba', abbreviation: 'PB' },
    { name: 'Pernambuco', abbreviation: 'PE' },
    { name: 'Piauí', abbreviation: 'PI' },
    { name: 'Paraná', abbreviation: 'PR' },
    { name: 'Rio de Janeiro', abbreviation: 'RJ' },
    { name: 'Rio Grande do Norte', abbreviation: 'RN' },
    { name: 'Rondônia', abbreviation: 'RO' },
    { name: 'Roraima', abbreviation: 'RR' },
    { name: 'Rio Grande do Sul', abbreviation: 'RS' },
    { name: 'Santa Catarina', abbreviation: 'SC' },
    { name: 'Sergipe', abbreviation: 'SE' },
    { name: 'São Paulo', abbreviation: 'SP' },
    { name: 'Tocantins', abbreviation: 'TO' },
];
export const COUNTRIES_NOT_REQUIRED_ZIP = [
    'AO', // Angola
    'AG', // Antigua and Barbuda
    'AW', // Aruba
    'BS', // Bahamas
    'BH', // Bahrain
    'BZ', // Belize
    'BJ', // Benin
    'BW', // Botswana
    'BF', // Burkina Faso
    'BI', // Burundi
    'CM', // Cameroon
    'CF', // Central African Republic
    'KM', // Comoros
    'CG', // Congo - Brazzaville
    'CD', // Congo - Kinshasa
    'CK', // Cook Islands
    'CI', // Côte d'Ivoire
    'CW', // Curaçao
    'DJ', // Djibouti
    'DM', // Dominica
    'GQ', // Equatorial Guinea
    'ER', // Eritrea
    'FJ', // Fiji
    'TF', // French Southern Territories
    'GM', // Gambia
    'GH', // Ghana
    'GD', // Grenada
    'GN', // Guinea
    'GY', // Guyana
    'HK', // Hong Kong SAR China
    'JM', // Jamaica
    'KE', // Kenya
    'KI', // Kiribati
    'LB', // Lebanon
    'MO', // Macau SAR China
    'MW', // Malawi
    'ML', // Mali
    'MR', // Mauritania
    'MU', // Mauritius
    'MS', // Montserrat
    'NR', // Nauru
    'NU', // Niue
    'PA', // Panama
    'QA', // Qatar
    'KN', // St. Kitts & Nevis
    'LC', // Saint Lucia
    'ST', // São Tomé & Príncipe
    'SC', // Seychelles
    'SL', // Sierra Leone
    'SB', // Solomon Islands
    'SO', // Somalia
    'ZA', // South Africa
    'SR', // Suriname
    'TZ', // Tanzania
    'TL', // Timor-Leste
    'TK', // Tokelau
    'TO', // Tonga
    'TT', // Trinidad & Tobago
    'TV', // Tuvalu
    'UG', // Uganda
    'AE', // United Arab Emirates
    'VU', // Vanuatu
    'YE', // Yemen
    'ZW', // Zimbabwe
];
export const UNSUPPORTED_COUNTRIES = [
    'UA', // Ukraine
    'RU', // Russia
    'CU', // Cuba
    'IR', // Iran
    'KP', // North Korea
    'SD', // Sudan
    'SY', // Syria
    'AS', // American Samoa
    'GU', // Guam
    'MP', // Northern Mariana Islands
    'PR', // Puerto Rico
    'UM', // United States Minor Outlying Islands
    'VI', // U.S. Virgin Islands
    'AF', // Afghanistan
    'AX', // Åland Islands
    'AQ', // Antarctica
    'BT', // Bhutan
    'BY', // Belarus
    'EC', // Ecuador
    'LA', // Laos
    'LY', // Libya
    'MN', // Mongolia
    'PG', // Papua New Guinea
    'RU', // Russia
    'SB', // Solomon Islands
    'SS', // South Sudan
    'TD', // Chad
    'TL', // Timor-Leste
    'TM', // Turkmenistan
    'WS', // Samoa
    'YE', // Yemen
];
